export type QualityMode = 'smart-hd' | 'maximum'

export type QualityProfile = {
  mode: QualityMode
  targetDpi: number
  jpegQuality: number
}

export const QUALITY_PROFILES: Record<QualityMode, QualityProfile> = {
  'smart-hd': { mode: 'smart-hd', targetDpi: 300, jpegQuality: 0.95 },
  maximum: { mode: 'maximum', targetDpi: 450, jpegQuality: 0.98 },
}

export function getScale(profile: QualityProfile): number {
  return profile.targetDpi / 72
}
